<template>
	<EmptyStreamLayout :icon="['far', 'eye-slash']">
		<template #title>
			<div class="empty-private-stream__title">
				{{ translate( "title" ) }}
			</div>
		</template>

		<template #description>
			<div class="empty-private-stream__description" v-html="translate( 'description' )"></div>
		</template>

		<template #actions>
			<div class="empty-private-stream__actions">
				<TeamingButton type="PRIMARY" @click="$emit('newNote')">{{ translate( "createNoteBtn" ) }}</TeamingButton>
			</div>
		</template>
	</EmptyStreamLayout>
</template>

<script>
import {
	TeamingButton
} from "@teaming/common-ui";

import EmptyStreamLayout from "./EmptyStreamLayout.vue";

export default {
	name: "EmptyPrivateStream",
	emits: [ "newNote", ],
	components: {
		EmptyStreamLayout,
		TeamingButton,
	},
	methods: {
		translate( key, args = {} ) {
			return this.$t( `common-team.components.EmptyPrivateStream.${ key }`, args );
		},
	},
};
</script>

<style lang="scss" scoped>
.empty-private-stream__title {
	padding-top: 1rem;
	padding-bottom: 1rem;
	@include font-and-line-for(1);
	font-weight: 600;
	color: $empty-private-stream-title;
}

.empty-private-stream__description {
	display: flex;
	flex-direction: column;
	gap: 1rem;
	@include font-and-line-for(0);
	font-weight: 450;
	color: $empty-private-stream-description;
	padding-bottom: 1rem;
}

.empty-private-stream__actions {
	display: flex;
	gap: 1rem;
}
</style>
